import styled, { css } from 'styled-components';

import { ATTACHMENTS } from 'newJs/config';

const { VIEW_MODE } = ATTACHMENTS;

const itemIcons = {
    action: css`
        .ico-product {
            margin: 0;
        ${({ theme }) => theme.currentViewMode === VIEW_MODE.GRID
        ? `
            font-size: 1.875rem;
            height: 2.1rem;
        `
        : `
            font-size: 1.1rem;
            height: 1.175rem;
            
        `}
        }
        .ico-product::before {
            top: 0;
        }
        .inx-fa-icon, .inx-io-icon, .glyphicon {
            ${({ theme }) => theme.currentViewMode === VIEW_MODE.GRID ? `font-size: 2rem;` : `font-size: 1.2rem;`}
        }

        div[class*="loader-container---"] {
            font-size: medium;
        }
    `,
    status: css`
        .item-status-icon {
            &.status-success:hover {
                color: var(--attachments-sucess);
            }
            &.status-failed {
                color: var(--color-fire);
            }
        }
    `
};

const Action = styled.a`
    align-items: center;
    color: var(--theme-attachment-item-text);
    display: inline-flex;
    justify-content: center;
    line-height: 1;
    margin: 0 0 1px 0;
    padding: 0;
    position: relative;
    text-decoration: none;
    font-size: 1.2rem;
    &:hover {
        color: var(--attachments-text-active);
    }
    &[data-type='success']:hover {
        color: var(--attachments-sucess);
    }
    ${({ theme }) => theme.currentViewMode === VIEW_MODE.GRID
        ? `
            margin: 0 8px;
            min-height: 1.17em;
            min-width: 1.17em;`
        : `
            margin: 0 4px;
            min-height: ${theme.gridGutterWidth * 3}px;
            min-width: ${theme.gridGutterWidth * 3}px;
    `}
    &:first-child {
        margin-left: 0;
    }
    .action-image {
        height: 100%;
        object-fit: fill;
        opacity: 0;
        position: absolute;
        width: 100%;
    }
    ${itemIcons.action}
    ${itemIcons.status}
`;

export default Action;
